var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 277,
    viewBox: "0 0 196 277",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.406 39.2018L290.841 0V27.0552L145.406 66.257V39.2018Z",
    fill: "#D09CE7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.8799 169.798L206.315 130.597V157.652L60.8799 196.854V169.798Z",
    fill: "#D09CE7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.8799 285.75L206.315 246.548V273.603L60.8799 312.805V285.75Z",
    fill: "#D09CE7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 247.244L145.435 208.042V235.097L0 274.299V247.244Z",
    fill: "#FFA100"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.8799 118.579L206.315 79.377V106.432L60.8799 145.634V118.579Z",
    fill: "#241F20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgRight);
export default __webpack_public_path__ + "static/media/bg-right.18f6a1deaccdf7549cfb157434c73497.svg";
export { ForwardRef as ReactComponent };